function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.43 76.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.04,1.9c-.66,1.23-1.1,11.25-1.16,26.25-.07,16.86-.52,25.99-1.47,29.91-2.31,9.49-1.91,12.35,2.17,15.46,2.31,1.76,5.19,2.86,8.28,3.16,4.22.41,5.23.08,9.21-2.98,4.28-3.3,4.46-3.64,4.34-8.44-.09-3.59-.87-6.13-2.78-9.01-2.21-3.34-2.89-6.08-4.06-16.42C16.07,17.81,13.2,5.97,9.34,1.7c-2.11-2.33-3.98-2.26-5.3.2",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87,7.75c2.06,4.78,5.51,23.08,6.54,34.67l.53,6h-5.38c-5.13,0-5.41-.14-5.96-2.88-.77-3.85-.72-30.79.07-37.38.35-2.89.96-5.25,1.37-5.25s1.67,2.17,2.82,4.83",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.78,50.54c2.52.67,7.67,9.07,8.57,13.98.48,2.59.04,3.61-2.62,6.14-1.76,1.67-4.22,3.34-5.46,3.72-3.06.92-8.43-.98-11.25-3.98l-2.31-2.46,1.82-7.98c1.57-6.89,2.18-8.11,4.42-8.93,3.21-1.18,4.02-1.24,6.84-.48",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.bdce4612f6f2b0029d0b13e31fe0ebaa.svg";
export { ForwardRef as ReactComponent };